import styled from 'styled-components';

interface IsActiveProp {
  isActive: boolean;
}

export const Container = styled.div<IsActiveProp>`
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  input[type='checkbox'] {
    display: none;
  }

  label {
    margin-top: 10px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    width: 58px;
    height: 14px;
    background-color: ${({ isActive }) =>
      isActive ? 'rgba(119,178,0,0.3)' : 'rgba(122, 122, 122, 0.3)'};
    cursor: pointer;
    border-radius: 100px;
    padding: 2px 10px;
  }

  span {
    font-size: 11px;
    line-height: 10px;
    color: #7a8799;
    font-weight: 500;
    color: #7a8799;
  }

  .toggle-text {
    font-weight: 500;
    color: #7a8799;
    margin: 0;
    margin-left: auto;

    transform: translateX(${({ isActive }) => (isActive ? -15 : 0)}px);

    transition: transform 0.4s ease;
  }
`;

export const PaintedBall = styled.div<IsActiveProp>`
  background-color: ${({ isActive }) => (isActive ? '#77B200' : '#7a7a7a')};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  transition: 0.4s ease left, 0.4s ease transform, background-color 0.4s;
  left: 14px;
  z-index: 2;

  transform: translateX(${({ isActive }) => (isActive ? 20 : -20)}px);
`;
